import { useMemo } from "react";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

import { queryClient } from "App";
import { formatError } from "helpers/formatError";
import { getRevenueOpportunityStatusTableColumns } from "components/RevenueOpportunityStatusTable/RevenueOpportunityStatusTableColumnsAndFilters";
import { REVENUE_OPPORTUNITY_STATUS_TABLE_CONSTANTS } from "components/RevenueOpportunityStatusTable/RevenueOpportunityStatusTableV3";
import { REVENUE_OPPORTUNITY_STATUS_PRESETS_TABLE_CONSTANTS } from "routes/revenue_opportunity_status_presets/RevenueOpportunityStatusPresetsTableV3";
import RevenueOpportunityService from "services/RevenueOpportunities";

export const invalidateRevenueOpportunityStatusQuery = () => {
  queryClient.invalidateQueries({
    queryKey: [REVENUE_OPPORTUNITY_STATUS_TABLE_CONSTANTS.queryKey],
  });
  // The selectable options and the presets that embed them both change with the
  // status list — deleting a status removes it from every preset.
  queryClient.invalidateQueries({ queryKey: ["revenue-opportunity-statuses"] });
  queryClient.invalidateQueries({
    queryKey: [REVENUE_OPPORTUNITY_STATUS_PRESETS_TABLE_CONSTANTS.queryKey],
  });
};

export const useRevenueOpportunityStatusMutations = ({ onDeleted } = {}) => {
  const remove = useMutation({
    mutationFn: id =>
      RevenueOpportunityService.deleteRevenueOpportunityStatus(id),
    onSuccess: () => {
      invalidateRevenueOpportunityStatusQuery();
      toast.success("Revenue Opportunity Status deleted");
      onDeleted?.();
    },
    onError: err =>
      toast.error(
        formatError(err, "Failed to delete Revenue Opportunity Status")
      ),
  });

  return { remove };
};

export const useRevenueOpportunityStatusTable = () => {
  const columns = useMemo(() => getRevenueOpportunityStatusTableColumns(), []);

  return {
    columns,
  };
};
